import { render, staticRenderFns } from "./society.vue?vue&type=template&id=b32f8cb0&scoped=true&"
import script from "./society.vue?vue&type=script&lang=ts&"
export * from "./society.vue?vue&type=script&lang=ts&"
import style0 from "./society.vue?vue&type=style&index=0&id=b32f8cb0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32f8cb0",
  null
  
)

export default component.exports